// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_a1f56c3","buttonText":"_76b2f07","regulatoryText":"_85bc5b0"};